export const defaultConfig = {
  // Local and UAT default. CI sets REACT_APP_API_BASE_URL at build time.
  baseAPIUrl: process.env.REACT_APP_API_BASE_URL || "https://shutteruat.azurewebsites.net/api/",
  currencySign: "$",
};
